export function getAnthologySimilarity(anthologies, type = "all") {
  return () =>
    fetch(
      `${process.env.REACT_APP_API_HTTP}://${process.env.REACT_APP_API_URL}:${
        process.env.REACT_APP_API_PORT
      }/api/v1/analytics/similarity/${anthologies.join("/")}?type=${type}`
    ).then((res) => res.json());
}
